import { HMethod, httpRequest } from "./http";

/**
 * 我的歌单
 * @returns {Promise<HttpState&{data:MusicVo[]}>}
 */
export function music_my() {
    return httpRequest("/api/v1/room/music/my", HMethod.GET, { searchValue: "" });
}